module.exports = __webpack_public_path__ + "static/media/UserWoman.877fabea.svg";